import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { useNavigate } from '@/js/libs/router';
import { useLogout } from '@/js/libs/use-auth';

import { useCleanupSessionStorageItems } from '../useCleanupSessionStorageItems.ts';
import { useLogoutRedirectPath } from './useLogoutRedirectPath.ts';

// Ends the session, drops the list states the pages keep in session storage, then leaves for the Post portal or opens
// the home page. The portal is resolved from the roles before the logout clears them.
export const useAppLogout = () => {
  const navigate = useNavigate();
  const logoutRedirectPath = useLogoutRedirectPath();
  const logout = useLogout();
  const cleanupSessionStorageItems = useCleanupSessionStorageItems();

  return useCallbackRef(() => {
    logout();
    cleanupSessionStorageItems();
    if (logoutRedirectPath) {
      window.location.assign(logoutRedirectPath);
    } else {
      navigate('/');
    }
  });
};
